export const PrimeFeatures = {
    network: [
        {
            name: 'internet',
            title: 'Безлимитный интернет',
            text: 'до 1000 Мбит/с',
        },
        {
            name: 'wifiSystem',
            title: 'Мощная Wi-Fi mesh система',
            text: 'во всем доме',
        }
    ],
    cellular: [
        {
            name: 'cellular',
            title: 'Мобильная связь *',
            text: '4 SIM, 250 мин, 60 ГБ',
        },
        {
            name: 'tvPlusMobile',
            title: 'TV+ mobile **',
            text: 'Бесплатный TV+ к каждой SIM',
        },
    ],
    tv: [
        {
            name: 'tvPlus',
            title: 'Телевидение TV+',
            text: '160+ телеканалов',
        },
        {
            name: 'tvStreams',
            title: 'Онлайн-кинотеатры',
            text: '8 онлайн-кинотеатров',
        },
    ],
    service: [
        {
            name: 'concierge',
            title: 'Консьерж сервис',
            text: 'Ваш персональный менеджер',
        },
        {
            name: 'bonuses',
            title: 'Бонусы от партнеров',
            text: 'Эксклюзивные предложения',
        },
        {
            name: 'family',
            title: 'Подписка Family',
            text: 'Бонусная услуга',
        },
    ],
};
